

import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Loading from 'vux/src/components/loading/index.vue'
import ViewBox from 'vux/src/components/view-box/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'

import cookie from '../../utils/cookie'

export default {
components: {
Tab,
TabItem,
Loading,
ViewBox,
XHeader
},
data () {
return {
}
},
computed: {
route () {
return this.$store.getters.route
},
/**
* 根据管理端标识动态显示联系人列表文本
* @returns {string} 管理端显示"客户列表"，订货端显示"客服列表"
*/
contactsText () {
const isManager = cookie.readCookie('is_manager')
return isManager === 'YES' ? '客户列表' : '客服列表'
}
},
methods: {
changePage (page) {
console.log()
}
}
}



// WEBPACK FOOTER //
// ./src/pages/components/NavBar.vue